import { baseUrl } from "@/utils";
import axios from "axios";

export const getLabayhPlusSubscriptionApi = async () => {
  try {
    const { data } = await axios.get(`${baseUrl}api/labayh-plus/usage`);
    // console.log("ddddd", { data })
    return data
  } catch (error) {
    // console.log("error", error?.response?.data)
    throw error
  }
}


export const getAppSettings = async () => {
  try {
    const { data } = await axios.get(`${baseUrl}api/app-settings`);
    return data
  } catch (error) {
    throw error
  }

};